import { useState } from 'react';
import { X } from '@/lib/icons';
import { Badge } from '@/components/ui/badge';

export function TagInput({
  tags,
  onChange,
  placeholder = '태그 추가…',
}: {
  tags: string[];
  onChange: (tags: string[]) => void;
  placeholder?: string;
}) {
  const [input, setInput] = useState('');

  const add = (raw: string) => {
    const t = raw.trim().replace(/^#/, '');
    if (t && !tags.includes(t)) onChange([...tags, t]);
    setInput('');
  };

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {tags.map((t) => (
        <Badge key={t} variant="tag" className="group gap-1">
          #{t}
          <button
            type="button"
            onClick={() => onChange(tags.filter((x) => x !== t))}
            className="text-fainter transition hover:text-danger"
            aria-label={`${t} 제거`}
          >
            <X className="size-3" />
          </button>
        </Badge>
      ))}
      <input
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault();
            add(input);
          } else if (e.key === 'Backspace' && !input && tags.length) {
            onChange(tags.slice(0, -1));
          }
        }}
        onBlur={() => input && add(input)}
        placeholder={placeholder}
        className="h-6 min-w-[80px] flex-1 bg-transparent text-xs text-ink placeholder:text-fainter focus:outline-none"
      />
    </div>
  );
}
